module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-learning-element"
  }, [_c('NavigationBar'), _vm._v(" "), _c('div', {
    staticClass: "learning-element-header"
  }, [_c('div', {
    staticClass: "cl-container header-title"
  }, [_vm._v(_vm._s(_vm.domainName))])]), _vm._v(" "), (_vm.busy) ? [_c('LoadingBounce')] : [_c('div', {
    staticClass: "learning-element-container"
  }, [_c('div', {
    staticClass: "row align-items-top"
  }, [_c('CatDomainRank'), _vm._v(" "), (_vm.learningElement) ? _c('CatElement', {
    attrs: {
      "learningElement": _vm.learningElement
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLearningElement) ? _c('InfiniteLoading', {
    staticClass: "w-100",
    on: {
      "infinite": _vm.infiniteHandler
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('LoadingBounce')], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  })]) : _vm._e()], 1)])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1081e0af","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-proficiency/views/CatLearningElement.vue
// module id = 1555
// module chunks = 1